// Mock data for Tarhun Catering – B2B Premium Catering

export const BRAND = {
  name: 'Tarhun Catering',
  tagline: 'Kurumsal Yemek Operasyonunun Sessiz Mimarı',
  phone: '0 549 363 33 02',
  phoneRaw: '+905493633302',
  fax: '0 262 349 66 28',
  email: 'operasyon@tarhuncatering.com',
  address: 'Mahmutpaşa Mah. Sancak Sok. No:10 Kullar — Başiskele / Kocaeli',
  addressShort: 'Başiskele / Kocaeli',
  web: 'www.tarhuncatering.com',
  whatsapp: 'https://wa.me/905493633302',
  logo: '/brand/tarhun-logo.png',
  instagram: 'https://www.instagram.com/tarhuncateringcom/',
  instagramHandle: '@tarhuncateringcom',
  facebook: 'https://www.facebook.com/profile.php?id=100071294004055',
  linkedin: 'https://www.linkedin.com/company/tarhuncatering',
};

// Instagram posts — homepage grid (links to be updated when user shares actual post URLs)
export const INSTAGRAM_POSTS = [
  {
    id: '01',
    image: '/instagram/post-01.webp',
    caption: 'Yemek değil, kurumsal güven üretiyoruz.',
    excerpt: 'Üretimden servise — tek elden operasyon.',
    href: 'https://www.instagram.com/tarhuncateringcom/',
  },
  {
    id: '02',
    image: '/instagram/post-02.webp',
    caption: '10.000+ kişilik günlük üretim kapasitesi.',
    excerpt: 'Yüksek kapasite. Planlı üretim. Güvenli süreç.',
    href: 'https://www.instagram.com/tarhuncateringcom/',
  },
  {
    id: '03',
    image: '/instagram/post-03.webp',
    caption: 'Hijyen, seçenek değil zorunluluktur.',
    excerpt: 'Kontrollü üretim · düzenli denetim · yüksek standart.',
    href: 'https://www.instagram.com/tarhuncateringcom/',
  },
  {
    id: '04',
    image: '/instagram/post-04.webp',
    caption: 'Endüstriyel güç. Şef dokunuşu.',
    excerpt: 'Lezzet, detayda saklıdır.',
    href: 'https://www.instagram.com/tarhuncateringcom/',
  },
  {
    id: '05',
    image: '/instagram/post-05.webp',
    caption: 'Sadece üretmiyoruz, eksiksiz teslim ediyoruz.',
    excerpt: 'Sıcak, hijyenik ve zamanında teslimat — işletmenizin yanındayız.',
    href: 'https://www.instagram.com/tarhuncateringcom/',
  },
  {
    id: '06',
    image: '/instagram/post-06.webp',
    caption: 'Büyük operasyonlar, güçlü ekiplerle yürür.',
    excerpt: 'Deneyimli kadro · koordineli çalışma · kesintisiz hizmet.',
    href: 'https://www.instagram.com/tarhuncateringcom/',
  },
  {
    id: '07',
    image: '/instagram/post-07.webp',
    caption: 'Yoğun tempoya, planlı beslenme.',
    excerpt: 'Çalışanlarınızın verimi, bizim için önceliktir.',
    href: 'https://www.instagram.com/tarhuncateringcom/',
  },
];

export const NAV = [
  { label: 'Anasayfa',      href: '/' },
  { label: 'Kurumsal',      href: '/hakkimizda' },
  { label: 'Hizmetimiz',    href: '/tasima-yemek' },
  { label: 'Sertifikalar',  href: '/sertifikalar' },
  { label: 'Lezzet Sırları',href: '/lezzet-sirlari' },
  { label: 'İletişim',      href: '/iletisim' },
];

// Official certificates & permits — public proof of operational discipline
export const CERTIFICATES = [
  {
    id: 'iso-22000-2018',
    indexLabel: '01',
    category: 'Uluslararası Standart',
    title: 'ISO 22000:2018',
    subtitle: 'Gıda Güvenliği Yönetim Sistemi',
    scope: 'Kendi ve müşteri tesislerinde toplu yemek üretimi ve sunumu',
    issuer: 'IQR International Certification Services',
    accreditation: 'IAF · IAS Accredited',
    certNo: 'FSMS-013699',
    initialDate: '29.12.2025',
    validUntil: '28.12.2026',
    image: '/certificates/iso-22000-2018.webp',
    description: 'Gıda güvenliği zincirini tedarikten servise kadar uluslararası standartla yöneten Tarhun, FSMS Kategori E altında belgelidir.',
  },
  {
    id: 'iso-9001-2015',
    indexLabel: '02',
    category: 'Uluslararası Standart',
    title: 'ISO 9001:2015',
    subtitle: 'Kalite Yönetim Sistemi',
    scope: 'Kendi ve müşteri tesislerinde toplu yemek üretimi ve sunumu',
    issuer: 'IQR International Certification Services',
    accreditation: 'IAF · IAS Accredited',
    certNo: 'QMS-013698',
    initialDate: '29.12.2025',
    validUntil: '28.12.2026',
    image: '/certificates/iso-9001.webp',
    description: 'Süreçlerin yazılı, ölçülebilir ve sürekli iyileştirilebilir olmasını şart koşan kalite çerçevesi.',
  },
  {
    id: 'iso-14001-2015',
    indexLabel: '03',
    category: 'Uluslararası Standart',
    title: 'ISO 14001:2015',
    subtitle: 'Çevre Yönetim Sistemi',
    scope: 'Kendi ve müşteri tesislerinde toplu yemek üretimi ve sunumu',
    issuer: 'IQR International Certification Services',
    accreditation: 'IAF · IAS Accredited',
    certNo: 'EMS-013698',
    initialDate: '29.12.2025',
    validUntil: '28.12.2026',
    image: '/certificates/iso-14001.webp',
    description: 'Atık, su ve enerji yönetiminde sürdürülebilir üretim ilkelerini benimseyen çevre yönetim sistemi.',
  },
  {
    id: 'iso-45001-2018',
    indexLabel: '04',
    category: 'Uluslararası Standart',
    title: 'ISO 45001:2018',
    subtitle: 'İş Sağlığı ve Güvenliği Yönetim Sistemi',
    scope: 'Kendi ve müşteri tesislerinde toplu yemek üretimi ve sunumu',
    issuer: 'GCR International Certifications UK Ltd.',
    accreditation: 'UK · England & Wales Registered',
    certNo: 'GCR/CERT-12.2025.006809',
    initialDate: '29.12.2025',
    validUntil: '28.12.2026',
    image: '/certificates/iso-45001.webp',
    description: 'Çalışan güvenliğini operasyonel disiplinin merkezine alan; iş kazası ve meslek hastalığı risklerini sistematik şekilde yöneten uluslararası standart.',
  },
  {
    id: 'isletme-kayit',
    indexLabel: '05',
    category: 'Resmi Belge',
    title: 'İşletme Kayıt Belgesi',
    subtitle: 'T.C. Gıda, Tarım ve Hayvancılık Bakanlığı',
    scope: 'Gıda üretimi yapan işletmeler — 5996 sayılı Kanun, 30. madde',
    issuer: 'Başiskele Kaymakamlığı — İlçe Gıda, Tarım ve Hayvancılık Müdürlüğü',
    accreditation: 'T.C. Devlet Onaylı',
    certNo: 'TR-41-K-004827',
    initialDate: '12.12.2012',
    validUntil: 'Süresiz',
    image: '/certificates/isletme-kayit-belgesi.webp',
    description: 'Gıda üretim faaliyetinin Tarım Bakanlığı nezdinde tescilli ve denetimli olduğunu kanıtlayan resmi belge.',
  },
  {
    id: 'isyeri-acma',
    indexLabel: '06',
    category: 'Yerel Yönetim',
    title: 'İşyeri Açma ve Çalışma Ruhsatı',
    subtitle: 'T.C. Başiskele Belediyesi · Zabıta Müdürlüğü',
    scope: 'Yemek üretimi ve dağıtım tesisi · 2. Sınıf Gayrisıhhi Müessese · 24 saat faaliyet',
    issuer: 'Başiskele Belediyesi Başkanlığı',
    accreditation: 'T.C. Belediye Ruhsatı',
    certNo: 'Sıra No: 2017/52',
    initialDate: '11.04.2017',
    validUntil: 'Yenilenmiş — 19.11.2017',
    image: '/certificates/isyeri-acma-ruhsati.webp',
    description: 'Kapalı 779 m² + açık 194 m² toplam 973 m² faaliyet alanı için belediye onaylı işletme ruhsatı.',
  },
];

// Anonymized industry portfolio (B2B competitive sensitivity — no client names)
export const INDUSTRY_PORTFOLIO = [
  { sector: 'Otomotiv',     scale: '2.400 kişilik üretim tesisi',      since: '2018' },
  { sector: 'Beyaz Eşya',   scale: '1.150 kişilik fabrika',            since: '2020' },
  { sector: 'Petrokimya',   scale: '850 kişilik rafineri kompleksi',   since: '2017' },
  { sector: 'İlaç',         scale: '620 kişilik üretim tesisi',        since: '2021' },
  { sector: 'Cam Üretim',   scale: '1.800 kişilik fabrika',            since: '2019' },
  { sector: 'Kimya',        scale: '480 kişilik özel kimyasal tesis',  since: '2022' },
  { sector: 'Lojistik',     scale: '950 kişilik depo & dağıtım',       since: '2020' },
  { sector: 'Çimento',      scale: '380 kişilik entegre tesis',        since: '2021' },
  { sector: 'Enerji',       scale: '720 kişilik santral',              since: '2019' },
  { sector: 'Plaza & Ofis', scale: '1.300 kişilik kurumsal kompleks',  since: '2022' },
];

export const HERO = {
  eyebrow: 'B2B Kurumsal Yemek Operasyonu',
  title: 'Şirketinizin yemek operasyonunu, dert olmadan yönetiyoruz.',
  subtitle: 'Fabrika, ofis ve şantiyelerinizde 365 gün; aynı saat, aynı kalite, aynı disiplin. Tarhun Catering — yemek değil, sürdürülebilir bir sistem teslim eder.',
  primaryCta: { label: 'Ücretsiz Teklif Al', href: '/iletisim' },
  secondaryCta: { label: 'Sistemi İncele', href: '/tasima-yemek' },
  image: '/site/menu-default.webp',
};

export const STATS = [
  { value: '14+', label: 'Yıllık operasyonel tecrübe' },
  { value: '10.000+', label: 'Günlük üretim & dağıtım kapasitesi' },
  { value: '120+', label: 'Aktif kurumsal müşteri' },
  { value: '%99,7', label: 'Zamanında teslim oranı' },
];

export const PAINS = [
  { title: 'Geç gelen, soğuk yemek', desc: 'Üretim hattınız bekleyemez. Vardiya yemeği saatinde, sıcaklığını koruyarak gelmek zorundadır.' },
  { title: 'Tutarsız kalite', desc: 'Bir gün lezzetli, ertesi gün tartışılan tabaklar. Çalışan memnuniyetini doğrudan etkiler.' },
  { title: 'Hijyen riskleri', desc: 'Tek bir gıda zehirlenmesi vakası operasyonu durdurur, itibarı zedeler.' },
  { title: 'Yönetilemeyen tedarikçi', desc: 'Telefonu açmayan, sözünü tutmayan yemek firmalarıyla zaman kaybediliyor.' },
];

export const SOLUTIONS = [
  { icon: 'ShieldCheck', title: 'Operasyonel Süreklilik', desc: 'Yedekli mutfak hattı, alternatif lojistik planı ve 7/24 saha koordinatörü ile hizmet kesintisiz devam eder.' },
  { icon: 'Timer', title: 'Saat Hassasiyeti', desc: 'Vardiya saatlerinize göre dakika bazlı planlama. Erken değil, geç değil — tam zamanında.' },
  { icon: 'Sparkles', title: 'Standartlaşmış Kalite', desc: 'HACCP, ISO 22000 ve 14 noktalı iç denetim ile her tabak aynı standartta.' },
  { icon: 'Users', title: 'Çalışan Memnuniyeti', desc: 'Aylık menü değerlendirme anketi, beslenme uzmanı onaylı dengeli kalori yönetimi.' },
  { icon: 'BadgeCheck', title: 'Tek Muhatap', desc: 'Size atanmış kurumsal müşteri yöneticisi. Tek telefon, tek imza, hızlı çözüm.' },
  { icon: 'TrendingUp', title: 'Ölçeklenebilir Sistem', desc: '50 kişiden 5.000 kişiye kadar; aynı disiplin, aynı standart, aynı tutarlılık.' },
];

export const PROCESS = [
  { step: '01', title: 'Saha Analizi', desc: 'Mutfak/yemekhane lokasyonu, vardiya saatleri, kişi sayısı ve özel diyet ihtiyaçları belirlenir.' },
  { step: '02', title: 'Menü Mühendisliği', desc: 'Beslenme uzmanı onaylı, mevsime göre 28 günlük döner menü hazırlanır.' },
  { step: '03', title: 'Üretim & Hijyen', desc: 'HACCP uyumlu merkezi mutfakta günlük taze üretim. 14 noktalı kalite kontrol.' },
  { step: '04', title: 'İzotermli Lojistik', desc: 'GPS takipli soğuk/sıcak zincir araçlar. Sıcaklık, dakikası dakikasına korunur.' },
  { step: '05', title: 'Sahada Servis', desc: 'Üniformalı saha personeli, hijyen protokolüyle servisi gerçekleştirir.' },
  { step: '06', title: 'Geri Bildirim & Optimizasyon', desc: 'Aylık çalışan anketi + KPI raporu ile hizmet sürekli iyileştirilir.' },
];

export const SERVICES = [
  {
    slug: 'tasima-yemek',
    title: 'Taşıma Yemek Hizmeti',
    audience: 'Fabrika, Ofis & Şantiyeler — 50+ Kişi',
    short: 'Fabrika, ofis ve şantiyeler için günlük kurumsal yemek operasyonu.',
    desc: 'Merkezi mutfağımızda günlük taze üretilen yemekler; izotermli araçlarla, vardiyanıza uygun saatte yemekhanenize teslim edilir. Üretimden servise tek elden, kesintisiz operasyon.',
    image: '/site/legacy-yemek-01.webp',
    badge: 'Tek Hizmet · Tek Disiplin',
  },
];

// ---- HOME-PAGE SPECIFIC ARRAYS ---- //

export const SYSTEM_STEPS = [
  {
    step: '01',
    title: 'Analiz',
    desc: 'Sahanızı, vardiya yapınızı ve kişi sayınızı ölçüyoruz. Mevcut süreçteki sürtünme noktalarını yazılı raporla aktarıyoruz.',
    image: '/site/menu-anayemek-fallback.webp',
  },
  {
    step: '02',
    title: 'Kurulum',
    desc: 'Beslenme uzmanı menüsü, izotermli lojistik planı ve atanmış saha ekibi ile sözleşme öncesi her detay yazılı protokole bağlanır.',
    image: '/site/menu-extra-1.webp',
  },
  {
    step: '03',
    title: 'Operasyon',
    desc: 'Her gün — aynı saat, aynı kalite, aynı disiplin. KPI raporu ile şeffaf operasyon, aylık çalışan anketiyle sürekli iyileştirme.',
    image: '/site/menu-extra-2.webp',
  },
];

export const WHY_TARHUN = [
  {
    icon: 'Microscope',
    title: 'Gıda Mühendisliği',
    desc: 'Her menü, lisanslı gıda mühendisi tarafından kalori ve besin dengesi açısından onaylanır.',
  },
  {
    icon: 'Factory',
    title: 'Yerinde Üretim',
    desc: 'Tesisinizdeki mutfakta anahtar teslim üretim altyapısı kurabilen sayılı firmadanız.',
  },
  {
    icon: 'ShieldCheck',
    title: 'ISO 22000 & HACCP',
    desc: 'Bağımsız denetimden sıfır uygunsuzlukla geçen sertifikalı süreçler.',
  },
  {
    icon: 'Layers',
    title: 'Ölçeklenebilir',
    desc: '50 kişiden 5.000 kişiye kadar — aynı disiplin, aynı tutarlılık, aynı standart.',
  },
];

export const FEATURED_TESTIMONIAL = {
  quote:
    'Üç farklı tedarikçiyi denedikten sonra Tarhun ile yolumuz kesişti. 18 aydır tek bir gecikmeli teslim yaşamadık. Çalışan memnuniyet anketinde yemek puanımız %58\'den %91\'e çıktı.',
  name: 'M. D.',
  title: 'İdari İşler Müdürü',
  company: 'Otomotiv yan sanayi · 1.200 kişilik tesis',
};

export const IMPACT = {
  big: 10000,
  caption: 'her gün, dakikası dakikasına servis edilen öğün',
  subStats: [
    { v: '120+', l: 'Aktif kurumsal müşteri' },
    { v: '%98', l: 'Çalışan memnuniyet oranı' },
    { v: '14 yıl', l: 'Operasyonel deneyim' },
  ],
};

export const CTA_PROCESS = [
  { num: '01', label: 'Formu doldurun' },
  { num: '02', label: 'Sizi arayalım' },
  { num: '03', label: 'Size özel plan' },
];

export const PROMISE_LABELS = [
  { text: 'Geç gelen servis', x: '7%', y: '14%' },
  { text: 'Soğuk yemek', x: '58%', y: '46%' },
  { text: 'Memnuniyetsiz personel', x: '14%', y: '78%' },
];

export const MENU_CATEGORIES = [
  { name: 'Çorbalar', image: '/site/menu-corbalar.webp', items: ['Mercimek Çorbası', 'Ezogelin', 'Tarhana', 'Yayla', 'İşkembe', 'Domates', 'Tavuk Suyu Şehriye', 'Mantar Kremalı'] },
  { name: 'Ana Yemekler', image: '/site/menu-anayemek.webp', items: ['Etli Nohut', 'Kuru Fasulye', 'Tas Kebabı', 'Hünkar Beğendi', 'Tavuk Sote', 'Karnıyarık', 'İzmir Köfte', 'Etli Bezelye'] },
  { name: 'Pilavlar & Makarnalar', image: '/site/menu-mezeler.webp', items: ['Şehriyeli Pilav', 'Bulgur Pilavı', 'İç Pilav', 'Sade Pirinç', 'Domates Soslu Makarna', 'Fırın Makarna', 'Tereyağlı Erişte', 'Kremalı Mantarlı Penne'] },
  { name: 'Salatalar & Mezeler', image: '/site/menu-tatlilar.webp', items: ['Mevsim Salata', 'Çoban Salata', 'Akdeniz Salata', 'Gavurdağı', 'Haydari', 'Atom', 'Acılı Ezme', 'Patlıcan Salatası'] },
  { name: 'Tatlılar', image: '/site/menu-extra-5.webp', items: ['Sütlaç', 'Kazandibi', 'Aşure', 'Revani', 'Kemalpaşa', 'Mevsim Meyve', 'Komposto', 'Tulumba'] },
  { name: 'İçecekler', image: '/site/menu-extra-4.webp', items: ['Ayran', 'Şalgam', 'Limonata', 'Soda', 'Meyve Suyu', 'Çay', 'Türk Kahvesi', 'Filtre Kahve'] },
];

export const REFERENCES = [
  { name: 'Erkunt Sanayi', sector: 'Otomotiv', logo: 'EK' },
  { name: 'Şişecam Topkapı', sector: 'Cam Üretim', logo: 'ŞC' },
  { name: 'Hyundai Assan', sector: 'Otomotiv', logo: 'HA' },
  { name: 'Tüpraş Rafineri', sector: 'Enerji', logo: 'TP' },
  { name: 'Ford Otosan', sector: 'Otomotiv', logo: 'FO' },
  { name: 'Arçelik', sector: 'Beyaz Eşya', logo: 'AR' },
  { name: 'Borusan Lojistik', sector: 'Lojistik', logo: 'BL' },
  { name: 'Akkim Kimya', sector: 'Kimya', logo: 'AK' },
  { name: 'Çimsa Çimento', sector: 'İnşaat', logo: 'ÇS' },
  { name: 'Petkim', sector: 'Petrokimya', logo: 'PT' },
  { name: 'Eczacıbaşı', sector: 'İlaç', logo: 'EZ' },
  { name: 'TOFAŞ', sector: 'Otomotiv', logo: 'TF' },
];

export const TESTIMONIALS = [
  { name: 'M. D.', title: 'İdari İşler Müdürü', company: 'Otomotiv yan sanayi · 1.200 kişilik tesis', quote: 'Üç farklı tedarikçiyi denedikten sonra Tarhun ile yolumuz kesişti. 18 aydır tek bir gecikmeli teslim yaşamadık. Sistem gerçekten işliyor.' },
  { name: 'S. Y.', title: 'İK Direktörü', company: 'Beyaz eşya · 1.150 kişilik fabrika', quote: 'Çalışan memnuniyet anketlerinde yemek puanımız %58\'den %91\'e yükseldi. Bu rakam Tarhun ile çalışmaya başladığımız aydan itibaren geldi.' },
  { name: 'A. K.', title: 'Şantiye Müdürü', company: 'Altyapı projesi · Kocaeli', quote: 'Şantiye operasyonu için aradığımız profesyonellikti. Hijyen protokolü, izotermli teslimat ve disiplin — kurumsal seviyede.' },
  { name: 'Dr. A. K.', title: 'Operasyon Direktörü', company: 'İlaç sanayi · 620 kişilik üretim tesisi', quote: 'Bizim sektörde hijyen tartışılmaz. Tarhun, HACCP standartlarımızı bizden daha sıkı uyguluyor. Kıyaslanamaz iş ortağı.' },
];

export const CERTIFICATIONS = [
  { name: 'ISO 22000', desc: 'Gıda Güvenliği Yönetim Sistemi' },
  { name: 'ISO 9001', desc: 'Kalite Yönetim Sistemi' },
  { name: 'HACCP', desc: 'Tehlike Analizi ve Kritik Kontrol Noktaları' },
  { name: 'TSE', desc: 'Türk Standartları Enstitüsü Belgesi' },
  { name: 'ISO 14001', desc: 'Çevre Yönetim Sistemi' },
  { name: 'Helal Sertifika', desc: 'GİMDES Onaylı Helal Üretim' },
];

export const FAQ = [
  { q: 'Minimum kaç kişilik servis veriyorsunuz?', a: 'Taşıma yemek hizmetimiz minimum 50 kişiden başlar. Yerinde üretim hizmetimiz 250 kişi ve üzeri tesisler için uygundur.' },
  { q: 'Hizmet bölgeniz neresi?', a: 'Merkez Kocaeli olmak üzere; İstanbul (Anadolu Yakası ve Avrupa Yakası), Sakarya, Yalova ve Bursa illerinde aktif hizmet veriyoruz.' },
  { q: 'Menüler nasıl belirleniyor?', a: 'Beslenme uzmanımız tarafından mevsime, sektöre ve çalışan profiline göre 28 günlük döner menü hazırlanır. Aylık olarak revize edilir.' },
  { q: 'Diyet ve özel beslenme talepleri karşılanıyor mu?', a: 'Diyabet, çölyak, vejetaryen, vegan, alerjen-free seçenekleri standart olarak sunulur. Detaylı liste sözleşmeye eklenir.' },
  { q: 'Sözleşme süreniz ne kadar?', a: 'Standart sözleşme 12 aylıktır. 3 ay deneme süreciyle başlar; memnun kalmazsanız sözleşme bedelsiz feshedilir.' },
  { q: 'Fiyatlandırma nasıl yapılıyor?', a: 'Kişi sayısı, vardiya yapısı, menü kategorisi ve lojistik mesafeye göre ücretsiz teklif hazırlanır. Sabit fiyat garantisi sağlanır.' },
];

export const NEWS = [
  { title: 'Tarhun Catering, ISO 22000:2018 belgesini yeniledi', date: '12 Haziran 2025', excerpt: 'Gıda güvenliği yönetim sistemimiz bağımsız denetimden sıfır uygunsuzlukla geçti.', image: '/site/menu-anayemek-fallback.webp' },
  { title: 'Yeni izotermli filo: 22 araç servise girdi', date: '03 Mayıs 2025', excerpt: 'GPS takipli, çift sıcaklık zonlu yeni nesil teslimat araçlarımız operasyonda.', image: '/site/menu-extra-6.webp' },
  { title: 'Kocaeli OSB ile uzun vadeli iş birliği', date: '21 Mart 2025', excerpt: '7 fabrikayı kapsayan 36 aylık çerçeve sözleşmesi imzalandı.', image: '/site/menu-extra-3.webp' },
];

// ─────────────────────────────────────────────────────────────────────
// TARHUN DEFTERİ — Lezzet Sırları (Premium Editorial Content)
// ─────────────────────────────────────────────────────────────────────
export const RUBRICS = [
  { slug: 'sefin-defterinden', label: 'Şefin Defterinden', desc: 'Profesyonel mutfağın sözsüz kuralları.' },
  { slug: 'baharat-atlasi',    label: 'Baharat Atlası',    desc: 'Tek bir baharat. Bir hikâye. Bir sır.' },
  { slug: 'mevsim-almanagi',   label: 'Mevsim Almanağı',   desc: 'Hangi malzeme, hangi hafta zirvesinde?' },
  { slug: 'mutfak-bilimi',     label: 'Mutfak Bilimi',     desc: 'Lezzetin arkasındaki kimya ve fizik.' },
];

export const ARTICLES = [
  {
    slug: 'tuzu-uc-zaman',
    rubric: 'sefin-defterinden',
    title: 'Tuzu üç farklı zamanda atın.',
    subtitle: 'Profesyonel mutfağın en az konuşulan, en güçlü kuralı — ve neden ev mutfağında bunu pek kimse yapmaz.',
    cover: '/articles/tuzu-uc-zaman.webp',
    readTime: '4 dk',
    wordCount: 612,
    publishedAt: '2026-02-12',
    featured: true,
    excerpt: 'Tuz, sebzelerin müziği gibidir. Yanlış zamanda eklerseniz tek nota duyarsınız; doğru zamanda atarsanız bir orkestra dinlersiniz.',
    content: [
      { type: 'p', text: 'Çoğu insan tuzu yemeğin sonuna doğru atar. Bazıları en başta. Profesyonel mutfakta ise tuz, üç ayrı zamanda — üç ayrı sebepten — kullanılır. Bu kural, deneyim arttıkça öğrenilir; ama bir kez öğrenildiğinde geri dönülmez.' },
      { type: 'h2', text: 'Birinci atış: malzemeyi açmak için' },
      { type: 'p', text: 'Sebze, et, kurubaklagil — hücreleri içlerine kapanmış halde başlarlar. Tuzun ilk işi bu kapıları aralamaktır. Soğanı doğradığınız anda hafif bir tutam tuz atın; 90 saniyede suyunu salar, doğru kıvama gelir, kahverengileşmesi çabuklaşır. Bu tuz pişmek değil, "açmak" içindir.' },
      { type: 'pullquote', text: 'Tuz, lezzetin kendisi değil — lezzetin anahtarıdır.' },
      { type: 'h2', text: 'İkinci atış: dengeyi kurmak için' },
      { type: 'p', text: 'Pişme orta noktasındayken — kaynar suyun ortasında, yağın çıtırdadığı anda — ikinci tuz girer. Bu, malzemelerin birbirini dengelediği andır. Domatesin ekşisi, soğanın tatlısı, biberin yakıcılığı bir yelpaze açar; tuz bu yelpazenin merkezine yerleşir ve hepsini bir araya getirir.' },
      { type: 'p', text: 'Bu aşamada az atılırsa lezzetler birbirinden kopuk durur; çok atılırsa hepsi maskelenir. Doğru ölçü, sadece tatma ile öğrenilir.' },
      { type: 'cta', text: 'Bu prensibi günde 8.200 öğünde kanıtlıyoruz.', label: 'Sistemi gör', href: '/hakkimizda' },
      { type: 'h2', text: 'Üçüncü atış: parlatma' },
      { type: 'p', text: 'Yemek tabağa konmadan önceki son saniyeler — burası şefin gizli alanıdır. Üzerine serpilen iri taneli pul tuz, sadece tat değil; bir doku, bir ses katar. Çıtır kabuğu olan bonfiledeki ya da meyve salatasındaki o son tuz, "bitiş tuzu"dur.' },
      { type: 'p', text: 'Mutfakta üç farklı tuz kullanırız: ince mutfak tuzu (1. atış), kaya tuzu (2. atış), pul tuz (3. atış). Bir öğünde üçü de farklı bir görev üstlenir. Bu, "tuzu sondan atma" alışkanlığını kıran küçük bir devrimdir — ve bir kez öğrenildiğinde, başka türlü pişirilemez.' },
      { type: 'note', text: 'Tarhun mutfağında her şef, ilk haftasında üç tuz prensibi üzerine teorik ve pratik bir eğitimden geçer.' },
    ],
    related: ['sogan-tatlanmadan', 'kekik-anadolunun-imzasi'],
  },
  {
    slug: 'sogan-tatlanmadan',
    rubric: 'sefin-defterinden',
    title: 'Soğan kahverengiye dönmeden tatlanmaz.',
    subtitle: 'Caramelization eşiği — neden bu eşiği aşmadan attığınız her şey sönük kalır?',
    cover: '/articles/sogan-tatlanmadan.webp',
    readTime: '3 dk',
    wordCount: 458,
    publishedAt: '2026-02-05',
    excerpt: 'Acelesi olan soğanı sevmez; ama sabırlı olan onu altın bir hazineye çevirir. Caramelization, profesyonel mutfağın en önemli "saatidir".',
    content: [
      { type: 'p', text: 'Soğanı tavaya atıp 4 dakika sonra üzerine et atan herkes biliyordur — yemek bir türlü "olmaz". Çünkü soğan henüz tatlanmamıştır. Tatlanmamış soğan, lezzeti taşıyamaz; bir bardak suyun çay olmadığı gibi.' },
      { type: 'h2', text: 'Caramelization nedir?' },
      { type: 'p', text: 'Soğanın içindeki şekerler ısı altında parçalanmaya başlar. 110°C civarında bu reaksiyon (Maillard tepkimesi de denir) hızlanır; soğan saydamlaşır, sonra altın sarısı, sonra kehribar ve sonunda mahogani kahverengisi olur. Her renk, bir tat eşiğine karşılık gelir.' },
      { type: 'pullquote', text: 'Sabırsız bir soğan, asla tatlı olmaz.' },
      { type: 'p', text: 'Profesyonel mutfakta soğanın "tatlanma" anı genellikle 12-18 dakikadır. Bu süre, ev kullanıcısının hazır olduğu süreden iki kat fazla — ve kalitenin ortaya çıktığı tek nokta.' },
      { type: 'cta', text: 'Tarhun mutfağında 12 dakika altı pişirilmiş hiçbir soğan tabağa çıkmaz.', label: 'Operasyonel disiplin', href: '/hakkimizda' },
      { type: 'h2', text: 'Eşik testi' },
      { type: 'p', text: 'Bir soğanın tatlanıp tatlanmadığını anlamanın en kolay yolu: bir kaşık alıp tadına bakmak. Eğer hâlâ "soğan" tadıyorsa, henüz hazır değildir. Tatlandığında — neredeyse meyveli, hafif karamel bir tat — yemek artık başlayabilir.' },
    ],
    related: ['tuzu-uc-zaman', 'bonfile-kollajen'],
  },
  {
    slug: 'kekik-anadolunun-imzasi',
    rubric: 'baharat-atlasi',
    title: 'Kekik: Anadolu\'nun gizli imzası.',
    subtitle: 'Akdeniz mutfağının üç yıldızlı şefinden, fabrika yemekhanesindeki bir tencere kuru fasulyeye kadar — kekiğin Türk mutfağındaki sessiz hâkimiyeti.',
    cover: '/articles/kekik-anadolunun-imzasi.webp',
    readTime: '6 dk',
    wordCount: 894,
    publishedAt: '2026-01-28',
    featured: true,
    excerpt: 'İzmir kekiği, Erzincan kekiği, Toroslar kekiği — coğrafyanın değişmesi, baharatın değişmesidir. Türk mutfağının bu görünmez patronunu tanıyalım.',
    content: [
      { type: 'p', text: 'Türkiye, dünya kekik üretiminin yaklaşık %70\'ini sırtlanır. Bu rakam, Türk mutfağının damak hafızasında neyin yattığını anlamak için yeterlidir. Kekik, bizim için bir baharat değil; neredeyse bir gramer kuralıdır.' },
      { type: 'h2', text: 'Üç farklı yörede üç farklı kekik' },
      { type: 'p', text: 'İzmir kekiği (Origanum onites), kuvvetli ve baskın. Et yemeklerine ve mangala biçilmiş kaftandır. Erzincan kekiği daha narin, neredeyse tatlıdır — sebze yemeklerinde ön plana çıkar. Toroslar\'ın yabani kekiği ise (Thymus vulgaris akrabası) keskin ve ilaç gibidir; geleneksel et çorbalarında ve dağ köfte tariflerinde kullanılır.' },
      { type: 'pullquote', text: 'Kekik üç farklı dilde konuşur. Hangi dili kullanacağınızı bilmek, profesyonelliktir.' },
      { type: 'h2', text: 'Ne zaman ekleneceği daha önemlidir' },
      { type: 'p', text: 'Kekik, ısıyla aroma kaybeder. Bu yüzden köklü mutfaklarda iki ayrı ekleme yapılır: pişme başında bir miktar (yağda kavrulurken — yağa aroma geçsin diye), pişme bitiminde bir miktar daha (taze aroma için). Bu çift atış kuralı, fast-food kalitesinden kurumsal mutfak kalitesine geçişin küçük ama belirleyici bir farkıdır.' },
      { type: 'note', text: 'Tarhun merkez mutfağında, kekik altı ayda bir tedarikçi denetimiyle yenilenir. Açık torbada bekletilen kekik, yedi günde aromasının yarısını kaybeder.' },
      { type: 'h2', text: 'Saklamanın sırrı' },
      { type: 'p', text: 'Kekiği şeffaf cam kavanozda saklamayın. Işık, uçucu yağları parçalar. İdeal saklama: koyu renk cam, kuru, serin yer. Eğer parmaklarınız arasında ovduğunuzda hâlâ keskin bir aroma yayıyorsa hâlâ canlıdır; aroma soluksa, kavanoz dolu olsa bile yenilenmelidir.' },
      { type: 'cta', text: 'Kurumsal mutfağımızda 14 farklı baharat, ayrı ayrı tedarik edilir.', label: 'Tedarik standartları', href: '/hakkimizda' },
      { type: 'h2', text: 'Bir tabağa kekik düşürmenin etiği' },
      { type: 'p', text: 'Profesyonel mutfakta kekik, "süs" değildir. Üzerine serpildiğinde anlamlı olduğu yerlere serpilir: sıcak çorba (sıcaklıkla aroma yayılır), ızgara et (yağ üzerinde tutunur), kuru fasulye (her kaşıkta birlikte). Soğuk, su bazlı yemeklere kekik düşürmek, müziği yanlış akortta çalmaktır.' },
      { type: 'p', text: 'Türk mutfağının zenginliği, bu küçük disiplinlerin toplamıdır. Kekik, onlardan sadece biri — ama anlatabilenleri bulmak güçtür.' },
    ],
    related: ['sumak-parlatici', 'tuzu-uc-zaman'],
  },
  {
    slug: 'sumak-parlatici',
    rubric: 'baharat-atlasi',
    title: 'Sumak: ekşi değil, parlatıcı.',
    subtitle: 'Türk mutfağının en yanlış anlaşılan baharatı. Sumak ekşi vermez — başka tatları gözle görülür kılar.',
    cover: '/articles/sumak-parlatici.webp',
    readTime: '4 dk',
    wordCount: 567,
    publishedAt: '2026-01-15',
    excerpt: 'Sumakı limon yerine kullananlar büyük bir hata yaparlar. Sumak ekşi yapmaz — ama tabaktaki diğer her şeyin parlamasını sağlar.',
    content: [
      { type: 'p', text: 'Sumakı limonun ucuz versiyonu sananlar yanılır. İkisi tamamen farklı şeyler yapar. Limon ekler, sumak parlatır.' },
      { type: 'h2', text: 'Sumak ne yapar?' },
      { type: 'p', text: 'Sumakın ana etkisi "brightening" denilen bir efekttir — yemekte zaten var olan tatları daha duyulur kılar. Soğanın üzerine sumak serpildiğinde, soğan daha tatlı; bulgur pilavının yanında sumak olduğunda, bulgur daha hafif görünür. Sumak hiç bir tatı eklemiyormuş gibi durur, ama tabağı tamamen değiştirir.' },
      { type: 'pullquote', text: 'Sumak görünmez bir reflektördür. Diğer her şey ona çarparak parlar.' },
      { type: 'h2', text: 'Doğru kullanım' },
      { type: 'p', text: 'Sumak pişirilmez — sıcak yemeğin ortasına atılan sumak çamur olur, aromasını yitirir. Servis öncesi son saniyede serpilmesi gerekir. Salatalarda tuz ile değil; tuz attıktan sonra ayrı bir adım olarak girer.' },
      { type: 'cta', text: 'Servis sırası, lezzet kadar önemlidir.', label: 'Operasyonel akışımız', href: '/tasima-yemek' },
      { type: 'h2', text: 'Bir test' },
      { type: 'p', text: 'Bir dilim domatese tuz atın. Tadına bakın. Bir dilim domatese sadece sumak serpin. Tadına bakın. Üçüncü dilim domatese tuz + sumak atın. Üçüncü, ilk ikisini aşar. İşte sumak budur — tek başına bir şey değil, dokunduğu her şeyi ileriye taşıyan bir parlatıcı.' },
    ],
    related: ['kekik-anadolunun-imzasi', 'tuzu-uc-zaman'],
  },
  {
    slug: 'subat-hamsi-mevsimi',
    rubric: 'mevsim-almanagi',
    title: 'Şubat: hamsi neden bugün başka?',
    subtitle: 'Karadeniz\'in soğuk Şubat suları, hamsiyi yıl içinde olabileceği en yağlı ve aromalı haline getirir. Ve bu, sadece dört hafta sürer.',
    cover: '/articles/subat-hamsi-mevsimi.webp',
    readTime: '5 dk',
    wordCount: 723,
    publishedAt: '2026-02-01',
    excerpt: 'Hamsi yıl boyu vardır, ama Şubat hamsisi başka bir balıktır. Yağ oranı %22\'ye çıkar; tuzlama, kızartma ve hatta fırınlama yöntemleri değişir.',
    content: [
      { type: 'p', text: 'Karadeniz\'in derin, soğuk suları Şubat ayında özel bir denge yaratır. Su sıcaklığı 7-9°C\'ye iner ve hamsinin yağ depolama metabolizması zirveye çıkar. Bu dört hafta, hamsinin yağ oranının %22\'lere kadar çıktığı tek dönemdir.' },
      { type: 'h2', text: 'Şubat hamsisinin pişirme sırrı' },
      { type: 'p', text: 'Yüksek yağ oranı, pişirme yöntemini değiştirir. Yaz hamsisini bol yağda kızartırsınız — kuru kalır. Şubat hamsisini ise neredeyse yağsız bir tava ya da fırın yeter; balık kendi yağında kavrulur, çıtırlığa ulaşır ve kuruluğunu kaybetmez.' },
      { type: 'pullquote', text: 'Mevsime saygı, mutfağın temel etiğidir.' },
      { type: 'h2', text: 'Tuz da değişir' },
      { type: 'p', text: 'Yağlı balık, tuzu farklı taşır. Şubat hamsisinde tuz, deri üzerine değil; balık fırına ya da tavaya girmeden 8 dakika önce iç boşluğuna konur. Bu süre, tuzun yağa karışıp her hücreye dağılması için yeterlidir.' },
      { type: 'cta', text: 'Tarhun mutfağında menü, mevsim takvimine göre yazılır — pazar talebine göre değil.', label: 'Mevsimsel menü yaklaşımımız', href: '/tasima-yemek' },
      { type: 'h2', text: 'Şubat\'ın diğer zirveleri' },
      { type: 'p', text: 'Hamsiye eşlik eden iki başka zirve: pırasa (kış sonu en tatlı dönemi) ve kara lahana (frost sonrası tatlanır). Üçü bir araya geldiğinde Karadeniz\'in en kısa ve en güçlü mevsimsel sofrası kurulur. Mart başında bu sofra dağılır; bir sonraki yıla kadar aynı dengeyi yakalamak imkânsızdır.' },
      { type: 'note', text: 'Tarhun, sezonsal menü değişikliklerini iki hafta önceden tüm müşterilerine bildirir.' },
    ],
    related: ['kekik-anadolunun-imzasi', 'bonfile-kollajen'],
  },
  {
    slug: 'bonfile-kollajen',
    rubric: 'mutfak-bilimi',
    title: 'Bonfilenin gevşeme sırrı: kollajen kimyası.',
    subtitle: 'Etin "yumuşak" olması bir tesadüf değil — protein yapısının kontrollü olarak çözündüğü kimyasal bir süreçtir.',
    cover: '/articles/bonfile-kollajen.webp',
    readTime: '7 dk',
    wordCount: 1024,
    publishedAt: '2026-01-08',
    excerpt: 'Sert et ile yumuşak et arasındaki fark, sadece kalitede değil; kimyada saklıdır. Kollajenin jelatin oluşturma sıcaklığı, 62°C\'den başlar.',
    content: [
      { type: 'p', text: 'Et yumuşaklığı, müşterinin "kalite" dediği şeyin %80\'idir. Ama bu yumuşaklık satın alınan etin kalitesinden değil, pişirme süreciyle aktive edilen kimyasal bir reaksiyondan gelir. Bu reaksiyonu bilen mutfak, ucuz parça etten birinci sınıf sonuç çıkartır.' },
      { type: 'h2', text: 'Kollajen nedir?' },
      { type: 'p', text: 'Kollajen, kasları bir arada tutan bağ dokusudur. Soğuk ve çiğ haldeyken sert ve yapışkandır. Sıcaklık 60°C\'yi geçtiğinde yapısı bozulmaya başlar; 70-80°C\'de jelatine dönüşür. Bu jelatin, etin "ağızda eriyen" o ikonik dokusunu yaratır.' },
      { type: 'pullquote', text: 'Sert eti yumuşatan, daha çok pişirme değil — doğru sıcaklıkta yeterince beklemektir.' },
      { type: 'h2', text: 'Yavaş pişirme neden işe yarar?' },
      { type: 'p', text: 'Tencerenin içindeki et, 80°C\'de uzun süre tutulduğunda kollajeni kademeli olarak jelatine çevirir. Bu süreç bir saatten az olursa et hâlâ sert kalır; üç saatten fazla olursa lifler ayrılır ve dağılır. Optimal aralık genellikle 90-120 dakikadır — ama bu, etin yaşına ve kesimine göre değişir.' },
      { type: 'cta', text: 'Tarhun mutfağında her et parçasının pişirme süresi, kasap raporundan kontrol edilir.', label: 'Kalite süreci', href: '/tasima-yemek' },
      { type: 'h2', text: 'Asit ve enzim — başka bir yol' },
      { type: 'p', text: 'Kollajeni kırmanın iki farklı yolu daha vardır: asit (limon, sirke, yoğurt — eti marine ederken kullanılır) ve enzim (papaya, ananas, kivi — protein yapılarını kıran proteaz enzimleri içerir). Türk mutfağının yoğurt kullanma alışkanlığı, aslında derinde bir kollajen yumuşatma stratejisidir; geleneksel mutfak biliminin bunu sezgisel olarak çözmüş olması etkileyicidir.' },
      { type: 'h2', text: 'Tek bir doğru sıcaklık' },
      { type: 'p', text: 'Bonfile için en kritik nokta iç sıcaklığın 54-58°C arasında tutulmasıdır. Bu aralık "medium-rare" olarak bilinir ve bilimsel olarak optimal kollajen-yumuşaklık dengesidir. 60°C\'yi geçtiği an su kaybeder, kuru görünür. 50°C\'nin altında bırakılırsa kollajen henüz aktif olmamıştır, sert kalır.' },
      { type: 'note', text: 'Tarhun mutfağında her et termal probla kontrol edilir; tabağa dijital olarak doğrulanmış sıcaklıkta çıkar.' },
      { type: 'h2', text: 'Sonuç' },
      { type: 'p', text: 'Yumuşak et, "iyi et" demek değildir. İyi pişirilmiş et demektir. Bu fark, profesyonel mutfak ile ev mutfağı arasındaki en derin sınırdır — ve bilim ile sanatın aynı tabakta buluştuğu noktadır.' },
    ],
    related: ['sogan-tatlanmadan', 'tuzu-uc-zaman'],
  },

  /* ─────────── ŞEFİN DEFTERİNDEN — yeni 3 ─────────── */
  {
    slug: 'pirinci-yikamanin-disiplini',
    rubric: 'sefin-defterinden',
    title: 'Pirinci yıkamanın görünmez disiplini.',
    subtitle: 'Üç dakika fazladan harcanan zaman, on katı kalitede bir pilav demektir. Yine de çoğu mutfakta atlanan adım budur.',
    cover: '/articles/pirinci-yikamanin-disiplini.webp',
    readTime: '4 dk',
    wordCount: 538,
    publishedAt: '2026-01-22',
    excerpt: 'Yıkanmamış pirinçten yapılan pilav, tanecikleri birbirine yapışık, hamur kıvamında çıkar. Çünkü yıkamanın görevi temizlik değil — yüzey nişastasını uzaklaştırmaktır.',
    content: [
      { type: 'p', text: 'Pirinci yıkamak, çoğu zaman bir hijyen ritüeli sanılır. Oysa profesyonel mutfakta pirinç yıkamanın asıl görevi başkadır: tanenin yüzeyindeki serbest nişastayı uzaklaştırmak. Bu nişasta, su ile kaynayan pirinç tanelerini birbirine yapıştırır ve pilav yerine "lapa" elde edilmesinin tek nedenidir.' },
      { type: 'h2', text: 'Suyun rengi her şeyi söyler' },
      { type: 'p', text: 'Pirinci ilk yıkadığınızda su süt beyazıdır — bu, yüzeydeki nişastanın çözünmesidir. Yıkamaya devam ettikçe su açılır; profesyonel kural, suyun yarı şeffaf olduğu noktada durmaktır. Tamamen şeffaf olana kadar yıkanan pirinç, gereken nişastanın da bir kısmını kaybeder ve aroma incelir.' },
      { type: 'pullquote', text: 'Yıkanmamış pirinç asla pilav olmaz. Aşırı yıkanmış pirinç ise kendini kaybeder.' },
      { type: 'h2', text: 'Beş veya yedi yıkama meselesi değil' },
      { type: 'p', text: 'Anneanne tarifleri "beş kez yıkayın" der. Profesyonel mutfakta sayı önemli değildir — su rengidir önemli olan. Süzgeç altında hafif basınçla, parmaklarla taneleri birbirine sürtmeden, üç ila beş kez su değiştirmek tipik olarak yeterlidir.' },
      { type: 'cta', text: 'Tarhun mutfağında pirinç, kabul aşamasından servis tabağına kadar 6 ayrı kontrol noktasından geçer.', label: 'Operasyonel akışımız', href: '/tasima-yemek' },
      { type: 'h2', text: 'Demleme suyunun matematiği' },
      { type: 'p', text: 'Yıkanmış pirinç ile yıkanmamış pirincin su emiş kapasitesi farklıdır. Yıkanmış pirinç için klasik oran 1:1.6 (bir ölçek pirince 1.6 ölçek su). Bu orana riayet edildiğinde, pirinç tane tane, parlak ve birbirine yapışmadan kalır.' },
      { type: 'note', text: 'Soğuk suya 20 dakika bekletmek (özellikle baldo veya basmati gibi uzun taneli pirinçlerde) tane bütünlüğünü %30 artırır.' },
    ],
    related: ['tuzu-uc-zaman', 'yagi-sicak-tavaya'],
  },

  {
    slug: 'celik-bicak-korelmez',
    rubric: 'sefin-defterinden',
    title: 'Çelik bıçak körelmez, ihmal edilir.',
    subtitle: 'Profesyonel mutfakta bıçak, sahibinin ne kadar disiplinli olduğunun en görünür kanıtıdır.',
    cover: '/articles/celik-bicak-korelmez.webp',
    readTime: '5 dk',
    wordCount: 678,
    publishedAt: '2026-01-18',
    excerpt: 'Bir bıçağın "körelmesi" diye bir şey yoktur. Sadece bilenmemesi vardır. Aradaki fark, bir mutfağın profesyonelliğini ölçen en sessiz testtir.',
    content: [
      { type: 'p', text: 'Profesyonel bir mutfağı ziyaret ettiğinizde önce dolapları, fırınları, malzeme rafını incelemezsiniz. Şefin bıçak çantasına bakarsınız. Çantanın düzeni, bıçakların durumu — orası bir ekibin disiplinini bir saniyede ele verir.' },
      { type: 'h2', text: 'Honlama ve bileme: aynı şey değildir' },
      { type: 'p', text: 'Honlama (honing rod ile yapılan), bıçağın ucundaki mikroskobik eğrilmeyi düzeltir. Bilemek (taş ile), gerçekten metal kazıyarak yeni bir kesim açısı oluşturur. Profesyonel mutfak: günlük honlama, ayda bir bileme. Ev mutfağında bu kural neredeyse hiç bilinmez ve "bıçağım körelmiş" diye fırlatılan bıçakların büyük çoğunluğu sadece honlanmamış bıçaklardır.' },
      { type: 'pullquote', text: 'Domatesi kanırtmadan keserseniz, bıçağınız sağlıklıdır. Aksi halde ihmaldedir.' },
      { type: 'h2', text: 'On sekiz derece kuralı' },
      { type: 'p', text: 'Avrupa tarzı (Alman) bıçaklar 20-22°, Japon tarzı bıçaklar 15-17° kesim açısına sahiptir. Türk mutfağı için tipik olarak 18° iyi bir orta noktadır — keskinlik ve dayanıklılığın dengesi. Bilemek bu açıyı korumak demektir; rastgele bir taşa sürtmek, açıyı bozar ve bıçağı kalıcı olarak zayıflatır.' },
      { type: 'cta', text: 'Tarhun ekibinde her şefin bıçağı, üç ayda bir bağımsız bir bıçak ustası tarafından kontrol edilir.', label: 'Operasyonel disiplin', href: '/hakkimizda' },
      { type: 'h2', text: 'Bıçak temizleme: sünger değil bez' },
      { type: 'p', text: 'Çelik, agresif kimyasal deterjana karşı hassastır. Profesyonel mutfakta bıçaklar nemli bir bezle silinir, bulaşık makinesine asla girmez. Ahşap kesme tahtasında kullanılır; cam, mermer veya seramik tahtalar bıçağı gözle görünmeyen aşındırır.' },
      { type: 'h2', text: 'Tek doğru saklama biçimi' },
      { type: 'p', text: 'Çekmeceye atılan bıçak, sadece bir kullanımda %15 keskinliğini kaybeder. Manyetik bar veya bıçak kütüğü zorunludur. Bıçak kütüğünde de slot dik değil, hafif eğimli olmalıdır — düz tutmak, bıçağın kendi ağırlığıyla üzerine bastırmasına neden olur ve uç noktadan başlayarak körleşir.' },
      { type: 'note', text: 'Tek bir profesyonel bıçak, doğru bakıldığında 30 yıl hizmet eder. İhmal edildiğinde 18 ayda bitkin düşer.' },
    ],
    related: ['yagi-sicak-tavaya', 'sogan-tatlanmadan'],
  },

  {
    slug: 'yagi-sicak-tavaya',
    rubric: 'sefin-defterinden',
    title: 'Yağı sıcak tavaya, malzemeyi kuru ele atın.',
    subtitle: 'Tava ısınmadan eklenen et hiç pişmez — buharlanır. İki çok farklı dünyadır bunlar.',
    cover: '/articles/yagi-sicak-tavaya.webp',
    readTime: '3 dk',
    wordCount: 472,
    publishedAt: '2026-01-10',
    excerpt: 'Pişirme ile haşlama arasındaki sınır, bir tek değişkene bağlıdır: tavanın sıcaklığı. Bu sınırı geçmeyen her tabak, ne kadar pahalı malzeme kullanırsa kullansın "kalitesiz" olur.',
    content: [
      { type: 'p', text: 'Profesyonel mutfakta en sık duyulan komut şudur: "Tava ısınsın, sonra koy." Bu cümle, ev mutfağında neredeyse hiç söylenmez ve mutfak ile mutfak arasındaki büyük farkı tam burada yatar.' },
      { type: 'h2', text: 'Buharlanma ile pişirme farkı' },
      { type: 'p', text: 'Tava 150°C\'den düşük bir sıcaklıktayken et eklendiğinde, et yüzeyindeki nem buharlaşmaya başlar. Bu buhar etin etrafını sarar ve eti haşlar — kahverengileşmeyi (Maillard reaksiyonu) tamamen engeller. Sonuç: gri renkli, sucuk gibi yumuşak ama lezzetsiz et.' },
      { type: 'pullquote', text: 'Ette kabuk yoksa, tabakta lezzet yoktur.' },
      { type: 'h2', text: 'Shimmer testi' },
      { type: 'p', text: 'Profesyonel mutfakta yağın doğru sıcaklıkta olup olmadığı "shimmer" (titreme) ile anlaşılır. Tavaya bir damla yağ atılır; yağ titremeye başladığında (~180°C), et eklenmeye hazırdır. Sigara dumanı çıkmaya başladıysa çok geçtir, tava soğutulur.' },
      { type: 'cta', text: 'Tarhun mutfağında her ızgara öncesi tava sıcaklığı dijital olarak ölçülür.', label: 'Tutarlı kalite süreci', href: '/hakkimizda' },
      { type: 'h2', text: 'Kuru malzeme kuralı' },
      { type: 'p', text: 'İçi sulu et, doğranmış soğan, ıslanmış sebze — hiçbiri sıcak yağa girmez. Önce kağıt havluyla kurulanır. Üzerinde 1 mm su olan biftek, kabuk bağlamayan biftektir. Bu çok küçük bir adım gibi durur ama sonuç bambaşkadır.' },
      { type: 'note', text: 'Profesyonel mutfaklarda her istasyonda kağıt havlu rulosu vardır — yıkanan her malzeme bezde değil, kağıtta kurutulur (bezdeki nem geri sızar).' },
    ],
    related: ['sogan-tatlanmadan', 'celik-bicak-korelmez'],
  },

  /* ─────────── BAHARAT ATLASI — yeni 3 ─────────── */
  {
    slug: 'karabiber-eski-para',
    rubric: 'baharat-atlasi',
    title: 'Karabiber: dünyanın en eski para birimi.',
    subtitle: 'Ortaçağ Avrupası\'nda kira karabiberle ödenirdi. Roma İmparatorluğu\'nu çökerten, tarçın değil bu siyah tanelerdi.',
    cover: '/articles/karabiber-eski-para.webp',
    readTime: '6 dk',
    wordCount: 836,
    publishedAt: '2026-02-08',
    excerpt: 'Karabiber tanesinin değeri, gram başına gümüşten yüksekti. Bugün marketten 12 liraya alıyoruz — ama mutfaklar onun gerçek dilini hâlâ bilmiyor.',
    content: [
      { type: 'p', text: 'Eğer dünya tarihinde en çok kan dökülmesine sebep olan baharat hangisi diye sorulsa, cevap karabiberdir. Ortaçağ Avrupası\'nda kiralar, harçlar ve hatta savaş tazminatları karabiberle ödenirdi. Bugün rafımızdaki o küçük kavanoz, bir zamanlar gümüşten daha kıymetliydi.' },
      { type: 'h2', text: 'Tellicherry ve Malabar farkı' },
      { type: 'p', text: 'Karabiberin en yüksek kalitesi Hindistan\'ın Malabar kıyısından gelir. İçinde Tellicherry, daha büyük ve daha geç hasat edilen tanelerden oluşan en üst sınıftır — taneler 4.25 mm\'den büyük olmalıdır. Bu inceltme, yalnızca aroma için değil; yüzey alanının yağ taşıma kapasitesi de değişir.' },
      { type: 'pullquote', text: 'Karabiberin lezzeti tanesinde değil — taneye temas eden hava ile sayılan saniyelerdedir.' },
      { type: 'h2', text: 'Piperine: keskinliğin kimyasal kanıtı' },
      { type: 'p', text: 'Karabiberin yakıcılığını veren bileşik piperinedir. Tane öğütüldüğü an, piperine havayla temas eder ve oksitlenmeye başlar. 30 dakika sonra aromasının %50\'si kaybolur. Süpermarketteki "öğütülmüş karabiber" kavanozları, piperinenin sadece kalıntılarını içerir; bu yüzden tatları "tozumsu" ve düz hisseder.' },
      { type: 'cta', text: 'Tarhun mutfağında karabiber, her servisten 5 dakika önce taze öğütülür.', label: 'Operasyonel akış', href: '/tasima-yemek' },
      { type: 'h2', text: 'Beyaz, yeşil, kırmızı: aynı meyve, farklı zaman' },
      { type: 'p', text: 'Karabiber, beyaz biber, yeşil biber ve nadir görülen kırmızı biber — hepsi Piper nigrum\'un meyveleridir. Yeşil biber tam olgunlaşmamıştır (taze, otsu); kırmızı biber tam olgun haldedir (hafif tatlı); siyah biber kararıncaya kadar kurutulmuştur (en güçlü piperine içerir); beyaz biber ise siyah biberden kabuk ayrılmış halidir (daha zarif ama daha az aromatik).' },
      { type: 'h2', text: 'Ne zaman atılmalı?' },
      { type: 'p', text: 'Karabiber, ısı ile aromasını agresif bir hızla kaybeder. Profesyonel kural: pişirme sırasında değil, servis öncesi öğüt ve atıl. Marinaya konacak karabiber bütün halde bırakılmalıdır; öğütülmüş halde marine edilen et, 8 saatte karabiberin keskinliğini tamamen kaybeder.' },
      { type: 'note', text: 'Tarhun bayatlamış karabiberi atar — açılmış kavanoz 6 aydan uzun raf ömrü görmez.' },
    ],
    related: ['kekik-anadolunun-imzasi', 'kimyon-kebabin-kahramani'],
  },

  {
    slug: 'pul-biber-isot-maras-urfa',
    rubric: 'baharat-atlasi',
    title: 'Pul biber: İsot, Maraş, Urfa farkı.',
    subtitle: 'Aynı kelime üç farklı dünyayı anlatır. Hangisinin nereye gittiğini bilmek profesyonelliğin en sessiz testidir.',
    cover: '/articles/pul-biber-isot-maras-urfa.webp',
    readTime: '5 dk',
    wordCount: 712,
    publishedAt: '2026-02-04',
    excerpt: 'Üç ayrı şehir. Üç ayrı kurutma yöntemi. Üç ayrı tat. Türk mutfağının en zengin baharat ailesinin haritasını çıkaralım.',
    content: [
      { type: 'p', text: 'Türkiye\'nin pul biber çeşitliliği dünyada eşi olmayan bir mirastır. "Pul biber" diyebileceğiniz tek bir baharat yoktur — Maraş, Urfa ve İsot, üç tamamen ayrı karakterdir. Birini diğerinin yerine kullanmak, tabağa söz vermenin yarısını çiğnemektir.' },
      { type: 'h2', text: 'Maraş biberi: parlak, hafif, dengeli' },
      { type: 'p', text: 'Kahramanmaraş\'ın özel iklimine ait Maraş biberi, güneşte kurutulur. Rengi koyu kırmızıdan kiraz kırmızısına döner; tadı orta keskinlikte, hafif tatlı meyvemsi notalar içerir. Yağ ile karıştırıldığında en parlak rengi veren biber budur — bu yüzden kuru fasulyeden mantı sosuna kadar geniş bir alanda hâkimdir.' },
      { type: 'pullquote', text: 'Maraş şenliktir; Urfa derinliktir; İsot esrarengizdir.' },
      { type: 'h2', text: 'Urfa biberi: koyu, topraksı, sigaramsı' },
      { type: 'p', text: 'Urfa\'da biber önce güneşte kurutulur, sonra geceleri bezle örtülür — bu fermentasyon sürecidir. Sonuç: koyu mor-siyah renk, çikolatamsı bir derinlik, hafif tütün notaları. Yakıcılığı Maraş\'tan azdır ama tat profili çok daha katmanlıdır. Lahmacun, çiğ köfte ve özellikle et dolmalarında Urfa, eşsizdir.' },
      { type: 'cta', text: 'Tarhun, üç ayrı pul biberi ayrı raflarda saklar — birbirine asla geçmez.', label: 'Tedarik standartları', href: '/hakkimizda' },
      { type: 'h2', text: 'İsot: Urfa\'nın kara aile bireyi' },
      { type: 'p', text: 'İsot, Urfa biberinin daha uzun fermente edilmiş ve daha az ışık görmüş halidir. Renk neredeyse siyah, koku tütsülenmiş. Modern Türk gastronomisi son 10 yılda İsot\'u yeniden keşfetti — dana ızgaradan yumurta sosuna kadar her yere giriyor. Ama dikkat: az bir miktar bile ezici olabilir; ölçü kritiktir.' },
      { type: 'h2', text: 'Doğru saklama' },
      { type: 'p', text: 'Üç biber de yağlı baharatlardır (zeytinyağı sürülerek kurutulurlar) — bu, hızlı bayatlamaları anlamına gelir. Açık kavanozda 3 ayda aroma kaybolur. Profesyonel mutfak: cam, koyu, küçük kavanozlar; bir kerede 3 aylık ihtiyaç kadar tedarik.' },
      { type: 'note', text: 'Maraş, Urfa ve İsot — coğrafi işaretli ürünlerdir. Etiketinde bu üç kelime geçmeyen "pul biber" tipik olarak Çin veya İspanya\'dan ithal edilen kalitesiz biberdir.' },
    ],
    related: ['karabiber-eski-para', 'kimyon-kebabin-kahramani'],
  },

  {
    slug: 'kimyon-kebabin-kahramani',
    rubric: 'baharat-atlasi',
    title: 'Kimyon: kebabın görünmez kahramanı.',
    subtitle: 'Kuzu eti tabağında bulunmayan tek malzeme — kimyon — varlığın eksikliğiyle hissedilir.',
    cover: '/articles/kimyon-kebabin-kahramani.webp',
    readTime: '5 dk',
    wordCount: 643,
    publishedAt: '2026-01-25',
    excerpt: 'Türk mutfağında kuzu ile kimyon, ayrılmaz bir çifttir. Ama doğru kullanmak — kavurarak, taze öğüterek — bu çifti gerçek bir evliliğe çevirir.',
    content: [
      { type: 'p', text: 'Bir lokantanın "Türk usulü kuzu" tabağı sıradan duruyorsa, sebep neredeyse her zaman aynıdır: kimyonu yanlış kullanmışlardır. Kimyon, Türk mutfağının kuzu ile yaptığı sözleşmedir; bu sözleşme bozulduğunda et lezzetli olamaz.' },
      { type: 'h2', text: 'Kimyon neden kuzu ile evlidir?' },
      { type: 'p', text: 'Kuzunun karakteristik aroması "lanolin" denilen bir yağ asidi grubundan gelir. Bu aroma, doğru kullanılırsa muhteşemdir; yanlış kullanılırsa "ağır", "yağlı" hisseder. Kimyondaki cuminaldehyde adlı bileşik, lanolinin ağırlığını dengeler ve onu hafifletir. Bu yüzden Orta Doğu, Hindistan ve Anadolu mutfaklarında kuzu hep kimyonla pişirilir.' },
      { type: 'pullquote', text: 'Bir kebapçı, kimyonunu öğütülmüş alıyorsa, müşteriye saygısı kadardır.' },
      { type: 'h2', text: 'Bütün tane vs öğütülmüş' },
      { type: 'p', text: 'Profesyonel mutfak, kimyonu daima bütün tane olarak satın alır. Kullanım anında: önce kuru tavada hafifçe kavrulur (30 saniye yeterlidir — koyu kahverengi olmaması önemli), sonra havanda taze öğütülür. Kavurma, cuminaldehyde\'nin uçucu yağlarını aktive eder; öğütülmüş kavanozlardakiler bunu yapamaz.' },
      { type: 'cta', text: 'Tarhun mutfağında kimyon her sabah taze kavrulup öğütülür.', label: 'Sabah ritüellerimiz', href: '/hakkimizda' },
      { type: 'h2', text: 'Sırf kuzu değil' },
      { type: 'p', text: 'Kimyon, mercimek çorbası, humus, falafel, hatta bazı pilavların gizli ayarcısıdır. Ölçü çok kritiktir: bir miktar düşük dozda kullanıldığında "tanımı" değiştirir, yüksek dozda kullanıldığında ise tabağı ezer. Profesyonel oran genelde gram et başına 0.5 gram öğütülmüş kimyondur.' },
      { type: 'h2', text: 'Bir uyarı' },
      { type: 'p', text: 'Kimyon ile karaman (siyah kimyon) karıştırılmamalıdır. Karaman çok daha yoğun, daha keskindir; bir tarif "kimyon" diyorsa, beyaz/altın renkli klasik kimyon kastedilmektedir. Karşılıklı kullanmak, tabağı bozar.' },
      { type: 'note', text: 'Anadolu\'nun en kaliteli kimyonu Konya ovasından gelir — etiketinde "Konya ürünü" yazısı bir kalite garantisidir.' },
    ],
    related: ['karabiber-eski-para', 'pul-biber-isot-maras-urfa'],
  },

  /* ─────────── MEVSİM ALMANAĞI — yeni 4 ─────────── */
  {
    slug: 'mart-nisan-enginar-kuzu',
    rubric: 'mevsim-almanagi',
    title: 'Mart-Nisan: enginar, taze fasulye, ilk dal kuzu.',
    subtitle: 'Bahar mutfağı, yılın en ihtiyatlı menüsünü ister. Erken davrananın eli de tabağı da çabuk yorulur.',
    cover: '/articles/mart-nisan-enginar-kuzu.webp',
    readTime: '5 dk',
    wordCount: 624,
    publishedAt: '2026-02-25',
    excerpt: 'Bahar başında pazar, eski sebzelerle yeni sebzeler arasında bir köprüdür. Yanlış tarafa basanın menüsü hep "tatsız bahar" tarifidir.',
    content: [
      { type: 'p', text: 'Bahar, mutfak için en aldatıcı mevsimdir. Hava ısınır, pazarda yeşillikler çoğalır — ama bu yeşilliklerin bir kısmı henüz olgunlaşmamıştır, bir kısmı ise aslında "kış sonu" sebzeleridir. Bahar menüsü yapan profesyonel mutfak, hangisinin hangi olduğunu bilmek zorundadır.' },
      { type: 'h2', text: 'Enginar: bahar krallığı' },
      { type: 'p', text: 'Enginar, mart sonu — nisan ortası arasında en şanslı haftalarını yaşar. Çiçeği henüz açmamış, dış yapraklar gevrek, içi fındık tatlısı. Mayıs sonuna doğru hızla "lifli" hale gelir ve sezonu kapanır. Bir enginarı satın alırken testi basittir: yapraklarını sıkın; "cıyak" sesi geliyorsa hâlâ tazedir.' },
      { type: 'pullquote', text: 'Mevsime bir hafta erken giren menü, üç gün sonra hayal kırıklığıdır.' },
      { type: 'h2', text: 'Taze fasulye: hızlı geçer, dikkat' },
      { type: 'p', text: 'İlk taze fasulye nisan başında pazara iner. Bu erken fasulye narindir, hızlı pişer (4-5 dakika), aroması olağanüstüdür. Ama yaşlı çiftçi diyor ki: "Mayıs ortasından sonra fasulye, geçen yılın fasulyesidir." O nedenle baharın ilk 6 haftası — eylülün son 4 haftası ile birlikte — fasulyenin altın penceresidir.' },
      { type: 'cta', text: 'Tarhun, mevsim sebzelerini iki haftalık menü revizyonu ile takip eder.', label: 'Mevsimsel menü yaklaşımımız', href: '/tasima-yemek' },
      { type: 'h2', text: 'İlk dal kuzu' },
      { type: 'p', text: 'Mart sonunda doğan kuzular, mayıs sonunda 6-8 haftalık olur. Bu yaş, kuzunun en hassas, en lezzetli olduğu yaştır. Süt kuzudan biraz daha gelişmiş ama yetişkin kuzunun lanolinli yağ profili henüz oluşmamıştır. Profesyonel kuzu satın alımları bu pencereye odaklanır; mayıs sonu — haziran ortası "ilk dal kuzu" mevsimidir.' },
      { type: 'h2', text: 'Bahar pazarının yanılgıları' },
      { type: 'p', text: 'Mart başında pazardaki domatesler hâlâ kış serasındandır — beklemek gerekir. Aynı şekilde "taze" diye satılan kabaklar genellikle eylülün depolama kabaklarıdır. Profesyonel mutfak, mevsimsel pazara haftalık değil, günlük gözle bakar.' },
      { type: 'note', text: 'Tarhun, bahar menüsünü iki etap halinde yayınlar: erken bahar (mart-nisan) ve geç bahar (mayıs).' },
    ],
    related: ['mayis-cilek', 'haziran-temmuz-domates'],
  },

  {
    slug: 'mayis-cilek',
    rubric: 'mevsim-almanagi',
    title: 'Mayıs: çilek mevsiminin 18 günlük altın penceresi.',
    subtitle: 'Yıl içinde sadece üç hafta. Sonra çilek, gerçekten "bambaşka bir şeydir".',
    cover: '/articles/mayis-cilek.webp',
    readTime: '4 dk',
    wordCount: 547,
    publishedAt: '2026-02-20',
    excerpt: 'Mayıs ortasının çileği ile ekim çileği — aynı meyveyi paylaşan iki farklı dünyadır. Aradaki fark, şeker değil; aroma kompozisyonudur.',
    content: [
      { type: 'p', text: 'Çilek, yıl boyu raflarda bulunur — ama gerçek çilek mayıs ortasından haziran başına kadar 18-21 gün arasında bir penceredir. O dönemde çilek olmasıdır.' },
      { type: 'h2', text: 'Aroma kompozisyonunu zaman değiştirir' },
      { type: 'p', text: 'Mayıs ortası çileğinde 360\'tan fazla aromatik bileşik tespit edilmiştir. Bunlardan en bilineni furaneol; çileğin "çilek gibi" kokmasının başlıca sorumlusu. Bu bileşikler güneş, sıcaklık ve doğal toprakta zenginleşir — sera koşullarında oluşmaz. Sonbahar çileği hâlâ tatlıdır, ama "çilek aroması" %60 daha azdır.' },
      { type: 'pullquote', text: 'Sera çileği seralık seraskerinin değil; tatlının değil, ışığın eksikliğidir.' },
      { type: 'h2', text: 'Brix değeri: tatlılığın matematiği' },
      { type: 'p', text: 'Profesyonel mutfak, sebze ve meyveleri çoğu zaman Brix refraktometresi ile ölçer. Mayıs çileği tipik olarak 9-12 Brix arasında değer verir; sera çileği 6-7. Aradaki fark, "tatlı" ve "şeker basılmış" arasındaki farktır.' },
      { type: 'cta', text: 'Tarhun, çilek mevsimini menüde sadece mayıs son iki ve haziran ilk hafta bulundurur.', label: 'Mevsimsel disiplinimiz', href: '/tasima-yemek' },
      { type: 'h2', text: 'Sapı kontrol edin' },
      { type: 'p', text: 'Saplı çilek almak ev mutfağında bir alışkanlık değildir; profesyonel mutfakta ise zorunluluktur. Sap, saklanma süresini iki kat uzatır ve çileğin "sapsız diliminde" başlayan oksidasyonu engeller. Sapı çıkarmak servisten 30 dakika önce yapılır — daha erkeni meyveyi sulandırır.' },
      { type: 'note', text: 'Türkiye\'nin en aromatik çilekleri Aksu (Antalya), Ödemiş (İzmir) ve Şile (İstanbul) bölgelerinden gelir — coğrafi işaret kalitesini garanti eder.' },
    ],
    related: ['mart-nisan-enginar-kuzu', 'haziran-temmuz-domates'],
  },

  {
    slug: 'haziran-temmuz-domates',
    rubric: 'mevsim-almanagi',
    title: 'Haziran-Temmuz: domates ne zaman kıvamına gelir?',
    subtitle: 'Domates olgunlaşmaz — sadece tatlanır. Bu basit bilgi, bir tabağın seviyesini değiştirir.',
    cover: '/articles/haziran-temmuz-domates.webp',
    readTime: '5 dk',
    wordCount: 671,
    publishedAt: '2026-02-15',
    excerpt: 'Domatesin en güçlü hâli, dalında sararmış-kızarmış arası geçtiği yedi gündür. Bu pencereyi yakalamak, yaz menüsünün omurgasıdır.',
    content: [
      { type: 'p', text: 'Domates yetiştiren her çiftçinin bildiği gerçek şudur: domates olgunlaşma süreciyle değil, "tatlanma" süreciyle iyi olur. Dalında geçirdiği son 7-10 gün — sararmaya başladığı ile tam kızardığı arasındaki o dönem — domatesin tüm yıl boyunca yapamayacağı şeyi yapar: lycopen, glutamat ve fruktoz birikir.' },
      { type: 'h2', text: 'Lycopen ve umami' },
      { type: 'p', text: 'Domatesteki kırmızı renk, lycopendir. Ama mutfak için daha kritik olan başka bir bileşik vardır: glutamik asit. Domates, doğanın en yüksek doğal glutamat (umami tat) içeren sebzelerinden biridir. Olgunlaşan bir domateste glutamat dört kat artar. Bu, fabrika domatesi ile köy domatesi arasındaki "lezzet uçurumunun" kimyasal kanıtıdır.' },
      { type: 'pullquote', text: 'Köy domatesi etiket değil, kimya farkıdır.' },
      { type: 'h2', text: 'Buzdolabı: domates için suç ortağı' },
      { type: 'p', text: 'Buzdolabında saklanan domates, içindeki aroma bileşiklerini inanılmaz hızda kaybeder. Soğuk, domatesteki "Z-3-hexenal" gibi yeşil-otsu aromatik bileşikleri tahrip eder. Profesyonel mutfak: domates her zaman oda sıcaklığında, doğrudan güneş görmeyen tezgahta saklanır.' },
      { type: 'cta', text: 'Tarhun, yaz menüsünün domates kısmını sadece köy domatesi ile yapar.', label: 'Tedarik standartlarımız', href: '/hakkimizda' },
      { type: 'h2', text: 'Hangi domates nereye gider?' },
      { type: 'p', text: 'Profesyonel mutfakta üç sınıf domates kullanılır: dilimleyici (slicer) domates — salata için, sıkı kabuklu, az sulu; chef\'s tomato — sosa giden, eti yumuşak ve sulu; cherry/küçük şişe — pişirme için, yoğun tatlı. Üçünü birbirinin yerine kullanmak, üç ayrı tabağı kaybetmek demektir.' },
      { type: 'h2', text: 'Domates suyu testini yapın' },
      { type: 'p', text: 'Kaliteli bir domatesi tezgahta yarıya bölün. Tohum boşluklarındaki sıvı şeffafsa, domates kıvamında değildir. Sıvı koyu kırmızı-altın rengindeyse, mükemmel olgunlaşmıştır — bu jelimsi doku içinde glutamatın büyük kısmı saklıdır.' },
      { type: 'note', text: 'Türkiye\'nin en aromatik domatesleri Antalya Kumluca, Çanakkale Bayramiç ve İzmir Tire bölgelerinden gelir.' },
    ],
    related: ['mayis-cilek', 'ekim-bal-kabagi'],
  },

  {
    slug: 'ekim-bal-kabagi',
    rubric: 'mevsim-almanagi',
    title: 'Ekim: bal kabağı ve frost\'un tatlandırıcı etkisi.',
    subtitle: 'İlk donun değdiği bal kabağı, dokunulmamış olandan üç kat daha tatlıdır. Bu, doğanın bir hediyesidir.',
    cover: '/articles/ekim-bal-kabagi.webp',
    readTime: '4 dk',
    wordCount: 584,
    publishedAt: '2026-02-10',
    excerpt: 'Bal kabağı, hasattan önce ilk donu görmüş olanı yıl içinde en lezzetli halidir. Buz, bitkide şaşırtıcı bir kimyasal dönüşüm başlatır.',
    content: [
      { type: 'p', text: 'Köy çiftçileri her zaman bilirdi: "Bal kabağını ilk frost\'tan sonra topla." Bu eski mutfak bilgisi modern bilim tarafından doğrulandı: don, bitkinin kendi savunma mekanizmasını tetikler ve nişastayı şekere dönüştürür.' },
      { type: 'h2', text: 'Soğuğa karşı şeker üretmek' },
      { type: 'p', text: 'Bitkiler, hücrelerinde donma riskine karşı doğal "antifreeze" mekanizmaları geliştirmiştir. İlk frost (yaklaşık 0°C\'ye düşüş) bal kabağı, balkabağı ve patatesteki nişasta moleküllerini parçalayarak fruktoz ve glikoz oluşturur. Bu basit şeker, bitki hücrelerinin donmasını engeller — ama aynı zamanda kabağı bizim için olağanüstü tatlı yapar.' },
      { type: 'pullquote', text: 'Bir bitki hayatını kurtarmak için ürettiği şeker — tabağa düşen lezzettir.' },
      { type: 'h2', text: 'Brix testi sonuçları' },
      { type: 'p', text: 'Don öncesi toplanan bal kabağı 7-9 Brix verir. Don sonrası toplananı 11-14 Brix\'e ulaşır. Bu fark, "iyi" ve "muhteşem" arasındaki farktır. Bu yüzden ekim sonu — kasım başı, bal kabağı için yıl içinde en kritik penceredir.' },
      { type: 'cta', text: 'Tarhun, kabak çorbasını sadece kasım-aralık aylarında menüde tutar.', label: 'Sezonluk yaklaşım', href: '/tasima-yemek' },
      { type: 'h2', text: 'Saklama: kabak yedi ay yaşar' },
      { type: 'p', text: 'Doğru saklanan bir bal kabağı, kasım hasadından mayıs sonuna kadar oda sıcaklığında bozulmadan dayanır. Şart: 10-15°C\'lik, kuru, karanlık bir yer ve sapın kesinlikle korunması (sap çıkarsa kabak 2 haftada çürür). Bu yüzden köy mutfaklarında bal kabağı kileri vardır — kış mevsimi boyunca taze sebze gibi kullanılır.' },
      { type: 'h2', text: 'Hangi tatlıya hangisi?' },
      { type: 'p', text: 'Bal kabağı tatlısı için "kestane kabağı" denilen tür ideal — eti sıkı, lifsiz, kabuğu ince. Çorba ve püre için "muskat kabağı" tercih edilir — eti tatlı, kabuğu kalın. Üç ayrı kabağı bilmemek, üç ayrı tabağı kaybetmek demektir.' },
      { type: 'note', text: 'Türkiye\'nin en aromatik bal kabakları Bolu, Düzce ve Karadeniz iç kesimlerinden gelir.' },
    ],
    related: ['haziran-temmuz-domates', 'mart-nisan-enginar-kuzu'],
  },

  /* ─────────── MUTFAK BİLİMİ — yeni 4 ─────────── */
  {
    slug: 'maillard-154-derece',
    rubric: 'mutfak-bilimi',
    title: 'Maillard reaksiyonu: 154°C\'nin ötesindeki sihir.',
    subtitle: 'Bir biftek neden iştah açıcı görünür? Cevap, 1912\'de bir Fransız kimyagerin keşfettiği bir reaksiyonda saklı.',
    cover: '/articles/maillard-154-derece.webp',
    readTime: '7 dk',
    wordCount: 924,
    publishedAt: '2026-02-18',
    featured: true,
    excerpt: 'Maillard reaksiyonu, mutfaktaki tek "sihir" anıdır. Tüm kavurmaların, kahve roastlama sürecinin ve kabuklu ekmeklerin arkasındaki tek tepkimedir.',
    content: [
      { type: 'p', text: '1912 yılında Fransız kimyager Louis-Camille Maillard, amino asitler ile şeker arasındaki belirli bir reaksiyonu tanımladı. Bu reaksiyon, modern gastronominin temelidir. Kahveden çikolataya, ekmeğin altın kabuğundan etin lezzetli kahverengileşmesine kadar — hepsi Maillard reaksiyonunun farklı tezahürleridir.' },
      { type: 'h2', text: 'Reaksiyon nedir?' },
      { type: 'p', text: 'Yüksek ısı altında (yaklaşık 154°C — 320°F üzerinde) amino asitler ile indirgen şekerler kimyasal bir dans başlatır. Sonuç: yüzlerce farklı aromatik molekül. Etin "kavruluk", ekmeğin "kabuklu" tadı, kahvenin "rich" notası, hepsi farklı amino asit + şeker kombinasyonlarının ürettiği farklı Maillard ürünleridir.' },
      { type: 'pullquote', text: 'Bir bifteği unutulmaz yapan tek şey: 154°C\'yi geçmiş olmasıdır.' },
      { type: 'h2', text: 'Neden 154°C?' },
      { type: 'p', text: 'Maillard reaksiyonu daha düşük ısılarda da başlar — ama çok yavaştır. 100°C civarında bile az miktarda gerçekleşir. Asıl patlama 154-180°C arasında olur. 200°C\'yi geçtiğinde reaksiyon o kadar hızlanır ki yanmaya dönüşür ve acı moleküller (akrolein gibi) baskın çıkar. Profesyonel mutfak bu pencerede dans etmeyi bilir.' },
      { type: 'cta', text: 'Tarhun ızgara tezgahları her servis öncesi 165°C\'ye kalibre edilir.', label: 'Operasyonel kalibrasyon', href: '/hakkimizda' },
      { type: 'h2', text: 'Suyun düşmanlığı' },
      { type: 'p', text: 'Maillard\'ın en büyük düşmanı sudur. Yüzeyinde su olan et, tencerede 100°C\'yi (suyun kaynama noktası) geçemez — su buharlaşana kadar Maillard başlamaz. Bu yüzden ıslak et asla kahverengileşmez, sadece griye döner. Kuru tutmak — kağıt havluyla — Maillard\'ı serbest bırakmaktır.' },
      { type: 'h2', text: 'Brining\'in matematiksel zaferi' },
      { type: 'p', text: 'Etin tuzla salamurada bekletilmesi (brining), suyun çıkmasını önler. Tuz, et hücrelerindeki proteini denatüre eder ve daha fazla sıvı tutmasını sağlar. Sonuç: Maillard sırasında et yüzeyi hızla kurur, kabuk bağlar, içi sulu kalır. Bu, tek bir tariften öğrenilebilecek en önemli teknik kazanımdır.' },
      { type: 'h2', text: 'Karamelizasyon ile farkı' },
      { type: 'p', text: 'Karamelizasyon, sadece şekerin ısı ile parçalanmasıdır (170°C+). Maillard ise amino asit + şeker kombinasyonudur. İkisi farklı reaksiyonlardır ama aynı tabakta yan yana gerçekleşebilirler. Soğanın kahverengileşmesi, esasında %70 karamelizasyon + %30 Maillard\'dır. Etin kahverengileşmesi tam tersidir.' },
      { type: 'note', text: 'Maillard reaksiyonunda oluşan moleküllerden en az 800\'ü tanımlanmıştır — ve hâlâ yeni olanlar bulunuyor.' },
    ],
    related: ['bonfile-kollajen', 'yagi-sicak-tavaya'],
  },

  {
    slug: 'yumurta-62-derece',
    rubric: 'mutfak-bilimi',
    title: 'Yumurtanın 62°C kuralı: protein denatürasyonu.',
    subtitle: 'Hollandaise sosu neden 64°C\'nin üstünde kesilir? Yumurta proteininin müziği.',
    cover: '/articles/yumurta-62-derece.webp',
    readTime: '6 dk',
    wordCount: 798,
    publishedAt: '2026-02-06',
    excerpt: 'Yumurta, mutfaktaki en kontrol edilebilir protein kaynağıdır — ama o kontrolü kullanmak için sıcaklığın altındaki kimyayı bilmek gerekir.',
    content: [
      { type: 'p', text: 'Yumurta, mutfak biliminin en zengin laboratuvarıdır. Aynı malzeme, sıcaklığa bağlı olarak yarı-sıvıdan kauçuğa kadar dokular alır. Bu dokunun arkasındaki tek değişken: sıcaklık. Ve her sıcaklığın bir adı vardır.' },
      { type: 'h2', text: 'Protein denatürasyonu nedir?' },
      { type: 'p', text: 'Yumurta beyazı, ovalbumin ve transferrin gibi proteinlerden oluşur. Bu proteinler, soğukken yumak halinde sarılmıştır. Sıcaklık arttıkça yumak açılır — bu "denatürasyon"dur. Açılan protein zincirleri birbirleriyle bağ kurmaya başlar; bu bağlar yumurtanın "katılaşmasını" oluşturur.' },
      { type: 'pullquote', text: 'Yumurta beyazı 62°C\'de duraksar. 64°C\'de teslim olur.' },
      { type: 'h2', text: 'Sıcaklık takvimi' },
      { type: 'p', text: 'Yumurta beyazı 62°C\'de başlar pıhtılaşmaya. 65°C\'de yarı katı olur. 80°C\'de tamamen sertleşir, 85°C\'de kauçuklaşır ve sülfür kokusu (yanmış kibrit kokusu) çıkarmaya başlar. Yumurta sarısı ise daha geç başlar: 64°C\'de pıhtılaşır, 70°C\'de tam katı olur. Bu farklılık, "yumurta cinema"sının kapısıdır.' },
      { type: 'cta', text: 'Tarhun mutfağında her yumurta servisi termal kontrole tabidir.', label: 'Operasyonel hassasiyet', href: '/hakkimizda' },
      { type: 'h2', text: 'Sous vide yumurtaları' },
      { type: 'p', text: '63°C\'de bir saat tutulan yumurta, "63 derece yumurtası" denilen efsanevi dokuya sahip olur: beyazı yarı saydam, krema kıvamında; sarı kıvamlı ama hâlâ akıcı. Bu yumurta tipini geleneksel pişirme metoduyla elde etmek imkansızdır — sadece kontrollü termal banyoda mümkündür.' },
      { type: 'h2', text: 'Hollandaise sosunu kim öldürür?' },
      { type: 'p', text: 'Hollandaise: yumurta sarısı + tereyağı + limon. Çok hassastır çünkü sarı 70°C\'yi geçtiği an pıhtılaşır ve sos kesilir. Doğru teknik: bain-marie\'de su 60°C\'yi aşmamalı, sos sürekli karıştırılmalı, tereyağı eriyik halde yavaşça eklenmeli. Bir saniye dikkatsizlik = bir kase yumurta kırıntısı.' },
      { type: 'h2', text: 'Pasteurization meselesi' },
      { type: 'p', text: 'Çiğ yumurtada Salmonella riski vardır. Yumurta 60°C\'de 3.5 dakika tutulduğunda Salmonella tamamen ortadan kalkar — ama yumurta hâlâ "çiğ" görünümlü kalır. Bu, mayonez ve Caesar dressing gibi tariflerin profesyonel mutfakta nasıl güvenli yapıldığının cevabıdır.' },
      { type: 'note', text: 'Tarhun mutfağında pastörize edilmiş yumurta, taze yumurta ile aynı raf alanında saklanmaz; iki ayrı dolap, iki ayrı protokol.' },
    ],
    related: ['bonfile-kollajen', 'maillard-154-derece'],
  },

  {
    slug: 'limon-ph-dengesi',
    rubric: 'mutfak-bilimi',
    title: 'Asit ve baz: limonun yemekteki gerçek görevi.',
    subtitle: 'Limon ekşi vermez — pH\'ı düşürerek tatları yeniden konuşturmaktır görevi. Bunu bilen şef ile bilmeyen arasında uçurum vardır.',
    cover: '/articles/limon-ph-dengesi.webp',
    readTime: '6 dk',
    wordCount: 752,
    publishedAt: '2026-01-30',
    excerpt: 'Bir tabakta "bir şey eksik" hissediliyorsa, sebep neredeyse her zaman asitsizlik\'tir. Limon, sirke veya yoğurtun bir damlası tabağı kurtarır.',
    content: [
      { type: 'p', text: 'Profesyonel mutfakta tabağı tatma sürecinde sıkça duyulan bir cümle vardır: "Asit eksik." Tat, koku ve doku iyi olabilir — ama eğer asit eksikse tabak hep "yarım" hisseder. Asit ne yapar? Cevap, dilin reseptör biyolojisindedir.' },
      { type: 'h2', text: 'Tat tomurcukları ve pH' },
      { type: 'p', text: 'Dilimizdeki tat tomurcukları belirli pH aralıklarına duyarlıdır. Yüksek pH\'lı (bazik) bir yemek, tat reseptörlerini "uyuştu" hisseder; lezzet düz ve sönük durur. Asit eklemek pH\'ı düşürür — reseptörler "uyanır", baskın olmayan tatlar kendini gösterir. Limon eklenmiş bir köfteyi düşünün: limon "ekşi" eklemez, tüm tabağın volumunu açar.' },
      { type: 'pullquote', text: 'Asitsiz tabak — sesi kapalı bir radyodur. Tüm istasyonlar oradadır ama duyamazsınız.' },
      { type: 'h2', text: 'Hangi asit, hangi tabağa?' },
      { type: 'p', text: 'Limon (sitrik asit) — taze, parlak, balık ve sebze. Sirke (asetik asit) — derin, oturmuş, et ve kuru baklagil. Yoğurt (laktik asit) — kremamsı, yumuşak, kırmızı et ve fırın. Şarap (tartarik asit) — karmaşık, kokulu, soslar. Hangisi tabağa ne katar — bunu bilmek profesyonel mutfak sanatıdır.' },
      { type: 'cta', text: 'Tarhun şefleri haftalık tat panelinde her tabağı pH yönünden değerlendirir.', label: 'Kalite süreci', href: '/hakkimizda' },
      { type: 'h2', text: 'Asitin ne zaman atılması gerekir?' },
      { type: 'p', text: 'Limon ısıyla aroma kaybeder; pişirme sırasında atılan limon, servis öncesi atılan limondan üç kat zayıftır. Profesyonel kural: asit en sona — servis öncesi son saniyelerde. İstisna: marine eden asitler (yoğurt, sirke), pişirme öncesi etkili olur, ama bunlar da pişirilirken ek bir asit ister servis aşamasında.' },
      { type: 'h2', text: 'Tuz ile asit ilişkisi' },
      { type: 'p', text: 'Tuz çok atıldıysa, asit dengeleyebilir. Tuz az atıldıysa, asit eksiği bunu maskeler. Tuz yeterli ama tabak hâlâ düz ise — neredeyse her zaman asit eksiktir. Bu üçlü matematiği — tuz, asit ve yağ — Samin Nosrat\'ın "Salt, Fat, Acid, Heat" kitabıyla popülerleşti, ama profesyonel mutfak bunu yıllardır biliyordu.' },
      { type: 'note', text: 'Tarhun mutfağında her sıcak menü servis öncesi mutlaka asit kontrolünden geçer.' },
    ],
    related: ['tuzu-uc-zaman', 'yumurta-62-derece'],
  },

  {
    slug: 'et-istirahat',
    rubric: 'mutfak-bilimi',
    title: 'Nem ve buhar: et neden istirahat etmeli?',
    subtitle: 'Pişmiş et, 8 dakika dinlenmeden kesilirse — yemediğinizin yarısını tabakta bırakırsınız.',
    cover: '/articles/et-istirahat.webp',
    readTime: '5 dk',
    wordCount: 612,
    publishedAt: '2026-01-12',
    excerpt: 'Etin "dinlendirilmesi" sadece bir gelenek değil — bilimsel zorunluluktur. Doğru yapılmazsa tabaktaki et %30 daha az sulu olur.',
    content: [
      { type: 'p', text: 'Profesyonel mutfakta et tezgahtan tabağa direkt geçmez. Mutlaka birkaç dakika "dinlenmeye" bırakılır. Bu adım — sadece ev mutfağında değil, çok pahalı restoranlarda bile sıkça atlanır. Ama atlandığında etin lezzetinin %30\'u tabakta değil, tahtada kaybolur.' },
      { type: 'h2', text: 'Sıcak etin içindeki basınç' },
      { type: 'p', text: 'Et pişerken kasları kasılır — protein lifleri sıkışır ve içindeki sıvı (su + protein + tat molekülleri) hücreler arası alanlara taşar. Eti pişirme bittiğinde keserseniz, bu "sıvı havuzu" basınçla dışarı fırlar; et tahtası ıslak, et kuru kalır. Dinlendirme, kasların yeniden gevşemesini ve sıvının hücrelere geri çekilmesini sağlar.' },
      { type: 'pullquote', text: 'Bir bifteği keserken tahtada gördüğünüz her damla — ağzınıza gitmeyen lezzettir.' },
      { type: 'h2', text: 'Ne kadar süre?' },
      { type: 'p', text: 'Genel kural: pişme süresinin %25\'i kadar dinlenme. 4 dakika pişen ince biftek 1 dakika dinlenir; 30 dakika pişen rosto 7-8 dakika dinlenir; 4 saat pişen yavaş kuzu 30+ dakika dinlenir. Bu süre boyunca etin merkez sıcaklığı 2-3°C daha artar (carryover cooking) — başka bir bilimsel detay.' },
      { type: 'cta', text: 'Tarhun mutfağında her et porsiyonu, servisten önce sıcak istirahat tezgahında bekletilir.', label: 'Sürecimiz', href: '/hakkimizda' },
      { type: 'h2', text: 'Folyo evet ama doğru' },
      { type: 'p', text: 'Et dinlenirken sıkı folyo ile sarılırsa buhar oluşur ve kabuk yumuşar (Maillard yüzeyi mahvolur). Doğru teknik: gevşek folyo veya hiç folyo. Sıcak ortamda (örn. açık fırının yanında) bekletmek yeterlidir — özellikle bonfile gibi büyük parçalar için.' },
      { type: 'h2', text: 'İstisna: ince et' },
      { type: 'p', text: 'Çok ince et (örneğin döner ya da kıyma) çoğu zaman dinlenmeye ihtiyaç duymaz çünkü tüm sıvı zaten yüzeyde dağılır ve hızlı emilir. Ama biraz daha kalın bir entrecôte için 5 dakika dinlenme — pişirme süresi kadar değerlidir.' },
      { type: 'note', text: 'Tarhun, kebap servisinden önce her şişin 90 saniye dinlendirilmesini protokol olarak uygular.' },
    ],
    related: ['bonfile-kollajen', 'maillard-154-derece'],
  },
];
